<template>
    <RegistrationStepPage step-name="regStart">
        <div class="d-flex mb-4">
            <img
                v-if="eventData.bild"
                class="d-none d-md-block event-image mr-4"
                :src="eventData.bild">
            <div class="flex-grow-1">
                <h1>{{ eventData.shortText }}</h1>
                <h4>{{ eventData.teaserText }}</h4>
            </div>
        </div>
        <div
            v-if="isGroupRegistrar"
            class="card w-100">
            <div class="card-body">
                <h2 v-if="groupRegistrationCreationMode">
                    <template v-if="changeWordingRegistrationBuy">
                        {{ $t('eventRegistration.start.newGroupBuy') }}
                    </template>
                    <template v-else>
                        {{ $t('eventRegistration.start.newGroupRegistration') }}
                    </template>
                </h2>
                <h2 v-else>
                    <template v-if="changeWordingRegistrationBuy">
                        {{ $t('eventRegistration.start.editGroupBuy') }}
                    </template>
                    <template v-else>
                        {{ $t('eventRegistration.start.editGroupRegistration') }}
                    </template>
                </h2>
                <base-input
                    v-model="groupName"
                    :label="$t('eventRegistration.start.groupName')"
                    :name="$t('eventRegistration.start.groupName')"
                    :rules="{required: true}"
                    input-classes="form-control-lg" />
                <base-input
                    v-model="groupRegistrarMail"
                    :label="$t('eventRegistration.start.groupRegistrarMail')"
                    :name="$t('eventRegistration.start.groupRegistrarMail')"
                    :rules="{required: true, email: true}"
                    input-classes="form-control-lg" />

                <div class="mt-5">
                    <h3>
                        <template v-if="changeWordingRegistrationBuy">
                            {{ $t('eventRegistration.start.groupParticipantLinkForBuy') }}:
                        </template>
                        <template v-else>
                            {{ $t('eventRegistration.start.groupParticipantLink') }}:
                        </template>
                    </h3>
                    <div class="registration-link-row">
                        <input
                            type="text"
                            class="form-control form-control-lg registration-link-input"
                            readonly
                            :value="groupParticipantLink"
                            @focus="$event.target.select()">
                        <base-button
                            type="secondary"
                            class="copy-btn form-control-lg"
                            @click="copyLink(groupParticipantLink)">
                            <font-awesome-icon
                                icon="copy"
                                fixed-width />
                            <span>{{ $t('eventRegistration.start.copyLink') }}</span>
                        </base-button>
                    </div>
                    <p style="font-size: smaller">
                        <template v-if="changeWordingRegistrationBuy">
                            {{ $t('eventRegistration.start.groupParticipantLinkForBuyExplanation') }}
                        </template>
                        <template v-else>
                            {{ $t('eventRegistration.start.groupParticipantLinkExplanation') }}
                        </template>
                    </p>
                </div>

                <div class="mt-3">
                    <h3>
                        <template v-if="changeWordingRegistrationBuy">
                            {{ $t('eventRegistration.start.groupRegistrarLinkForBuy') }}:
                        </template>
                        <template v-else>
                            {{ $t('eventRegistration.start.groupRegistrarLink') }}:
                        </template>
                    </h3>
                    <div class="registration-link-row">
                        <input
                            type="text"
                            class="form-control registration-link-input"
                            readonly
                            :value="groupRegistrarLink"
                            @focus="$event.target.select()">
                        <base-button
                            type="secondary"
                            class="copy-btn"
                            @click="copyLink(groupRegistrarLink)">
                            <font-awesome-icon
                                icon="copy"
                                fixed-width />
                            <span>{{ $t('eventRegistration.start.copyLink') }}</span>
                        </base-button>
                    </div>
                    <p style="font-size: smaller">
                        <template v-if="changeWordingRegistrationBuy">
                            {{ $t('eventRegistration.start.groupRegistrarLinkForBuyExplanation') }}
                        </template>
                        <template v-else>
                            {{ $t('eventRegistration.start.groupRegistrarLinkExplanation') }}
                        </template>
                    </p>
                </div>
            </div>
        </div>
        <div
            v-if="isGroupParticipant"
            class="card w-100">
            <div class="card-body">
                <h2>{{ $t('eventRegistration.start.groupRegistration') }}</h2>
                <div class="h1 font-weight-600">
                    {{ groupName }}
                </div>
            </div>
        </div>
        <div
            v-if="isCaregiver"
            class="card w-100">
            <div
                v-if="caregiverCheckToken && (!personsHaveBeenCreatedAfterCaregiverSelection || !caregiver)"
                class="card-body">
                <h2>{{ $t('eventRegistration.start.caregiverRegistration') }}</h2>
                <BaseSelect
                    :label="$t('eventRegistration.start.caregiverSelect')"
                    required
                    :rules="{required: true}"
                    :model-value="caregiverToken"
                    @update:model-value="handleCaregiverSelect">
                    <BaseOption
                        v-for="caregiverOption in caregiverOptions"
                        :key="caregiverOption.uuid"
                        :label="caregiverOption.Teilnahmefunktionname"
                        :value="caregiverOption.uuid" />
                </BaseSelect>
            </div>
            <div
                v-else-if="!!caregiver"
                class="card-body">
                <h2>{{ $t('eventRegistration.start.caregiverRegistration') }}</h2>
                <div class="h1 font-weight-600">
                    {{ caregiver.Teilnahmefunktionname }}
                </div>
            </div>
        </div>
    </RegistrationStepPage>
</template>

<script>
import registrationGroupMixin from "@/mixins/registration/registrationGroupMixin";
import registrationCaregiverMixin from "@/mixins/registration/registrationCaregiverMixin";
import registrationOnlineRegistrationFieldsMixin from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";
import RegistrationStepPage from '@/components/farbcode-core/Registration/RegistrationStepPage'

export default {
    name: "RegStart",
    components: {
        RegistrationStepPage
    },
    mixins: [registrationGroupMixin, registrationCaregiverMixin, registrationOnlineRegistrationFieldsMixin],
    methods: {
        copyLink(link) {
            navigator.clipboard.writeText(link);

            this.$notify({
                message: this.$t('eventRegistration.start.copiedLinkToClipboard'),
                type: "success",
                timeout: 3000
            })
        }
    }

}
</script>

<style lang="scss" scoped>
@use "sass:map";

.event-image {
    height: 100px;
    width: 100px;
    object-fit: cover;
}

.registration-link-input {
    background-color: transparent;
    cursor: pointer;
}

.registration-link-row {
    display: flex;
    flex-wrap: wrap;
    gap: map.get($spacers, 3);

    input {
        flex-grow: 1;
        width: auto;
    }

}
</style>
